export default "__VITE_ASSET__Dgo0zjrr__"